import { type ReactNode, useId } from 'react';

interface FormSectionProps {
  title: string;
  description?: ReactNode;
  status?: ReactNode;
  children: ReactNode;
}

export const FormSection = ({ title, description, status, children }: FormSectionProps) => {
  const headingId = useId();
  return (
    <section aria-labelledby={headingId} className="grid gap-x-10 gap-y-5 border-t py-8 first:border-t-0 first:pt-0 last:pb-0 lg:grid-cols-[minmax(0,12rem)_minmax(0,1fr)]">
      <header className="flex flex-col items-start gap-1.5">
        <h3 className="text-base font-semibold tracking-tight" id={headingId}>
          {title}
        </h3>
        {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
        {status}
      </header>
      <div className="flex min-w-0 flex-col gap-6">{children}</div>
    </section>
  );
};
FormSection.displayName = 'FormSection';
